import React, { useState } from 'react';
import styled from 'styled-components';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import ResetPasswordForm from './ResetPasswordForm';
import { useLocation, useNavigate } from 'react-router-dom';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  padding: 2rem;
  background-color: ${({ theme }) => theme.colors.background};
  overflow-y: auto;
`;

const AuthCard = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 2rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 80vh;
  overflow-y: auto;
  margin: 2rem 0;
`;

const Logo = styled.div`
  margin-bottom: 2rem;
  text-align: center;
  
  img {
    max-width: 180px;
    height: auto;
  }
`;

// Type pour les différentes vues d'authentification
type AuthView = 'login' | 'register' | 'forgot-password' | 'reset-password';

const AuthPage: React.FC = () => {
  // Utiliser les hooks sans condition
  const location = useLocation();
  const navigate = useNavigate();
  
  // Vérifier si nous sommes sur la page de réinitialisation du mot de passe
  const isResetPasswordPage = location.pathname === '/reset-password';
  
  // État pour suivre la vue actuelle
  const [currentView, setCurrentView] = useState<AuthView>(
    isResetPasswordPage ? 'reset-password' : 'login'
  );

  // Gestionnaires pour changer de vue
  const handleSwitchToLogin = () => setCurrentView('login');
  const handleSwitchToRegister = () => setCurrentView('register');
  const handleSwitchToForgotPassword = () => setCurrentView('forgot-password');
  
  // Gestionnaire pour la réussite de la réinitialisation du mot de passe
  const handleResetSuccess = () => {
    navigate('/login');
    setCurrentView('login');
  };

  // Rendu du formulaire en fonction de la vue actuelle
  const renderForm = () => {
    switch (currentView) {
      case 'login':
        return (
          <LoginForm 
            onSwitchToRegister={handleSwitchToRegister}
            onSwitchToForgotPassword={handleSwitchToForgotPassword}
          />
        );
      case 'register':
        return <RegisterForm onSwitchToLogin={handleSwitchToLogin} />;
      case 'forgot-password':
        return <ForgotPasswordForm onSwitchToLogin={handleSwitchToLogin} />;
      case 'reset-password':
        return <ResetPasswordForm onSuccess={handleResetSuccess} />;
      default:
        return <LoginForm 
          onSwitchToRegister={handleSwitchToRegister}
          onSwitchToForgotPassword={handleSwitchToForgotPassword}
        />;
    }
  };

  return (
    <PageContainer>
      <AuthCard>
        <Logo>
          <img src="/logo.png" alt="Immo Prospect" />
        </Logo>
        {renderForm()}
      </AuthCard>
    </PageContainer>
  );
};

export default AuthPage;

